// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'


//局部引入 vant
import { Button } from 'vant';
Vue.use(Button);
import { NoticeBar } from 'vant';
Vue.use(NoticeBar);
import { Lazyload } from 'vant';
Vue.use(Lazyload);
import { Icon } from 'vant';
Vue.use(Icon);
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe).use(SwipeItem);
import { Field } from 'vant';
Vue.use(Field);
import { Pagination } from 'vant';
Vue.use(Pagination);



Vue.prototype.axios = axios;

Vue.prototype.formatDate = function(format = '',value){
  const date = new Date(value*1000);
  var Y = date.getFullYear(),
  m = date.getMonth() + 1,
  d = date.getDate(),
  H = date.getHours(),
  i = date.getMinutes(),
  s = date.getSeconds();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  H = H < 10 ? '0' + H : H;
  i = i < 10 ? '0' + i : i;
  s = s < 10 ? '0' + s : s;
  if(format != ''){
    var fmt = format;
    fmt = fmt.replace(/Y/,Y);
    fmt = fmt.replace(/m/,m);
    fmt = fmt.replace(/d/,d);
    fmt = fmt.replace(/H/,H);
    fmt = fmt.replace(/i/,i);
    fmt = fmt.replace(/s/,s);
    if(fmt != format){
      return fmt;
    }
  }
  const t = Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s;
  return t;
};


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js